import * as PIXI from 'pixi.js'
import SpineEditor from './spineEditor'
import { getSpinesFromStage, getStageRef, getSpineName } from '../../utils'

const { Container, spine } = PIXI

export default class ActiveSpineEditor extends React.Component {
  state = {}
  componentWillMount() {
    this.refreshSpineList()
  }

  setActiveSpine = (sp) => {
    this.setState({ activeSpine: sp })
  }

  refreshSpineList = () => {
    let _id = 0
    const assets = getSpinesFromStage().map(a => ({ spine: a, id: _id++ }))

    this.setState({ availableSpines: assets })
  }

  render() {
    const { availableSpines = {}, activeSpine } = this.state

    return (
      <div id="activeSpineEditor">
        <div className="spineList">
          <input type="button" value="Refresh" onClick={this.refreshSpineList} />
          <ul style={{ listStyleType: 'none' }}>
            { availableSpines.map(sp =>
              <li key={`${sp.id}-`} onClick={() => { this.setActiveSpine(sp.spine) }}>{`${getSpineName(sp.spine.spineData.hash)} Spine!`}</li>
            )}
          </ul>
        </div>
        { activeSpine && (
          <SpineEditor spine={activeSpine} />
        )}
      </div>
    )
  }
}